import {
  PAYLATER_AUTH_FLOW,
  SECURED_INSTALLMENTS_FLOW,
  UNIVERSAL_ACTIVATION_FLOW,
  UPAG_AUTH_FLOW
} from 'const/constants'
import type {
  AuthenticateMutationOption,
  AuthenticateUseMutationProps
} from 'services/authenticateMutation/authenticateMutation.types'
import defaultConfig from 'const/config'
import makeSecuredAuthenticateOptions from './makeSecuredAuthenticateOptions'
import makePaylaterAuthenticateOptions from './makePaylaterAuthenticateOptions'
import makeUniversalActivationAuthenticateOptions from './makeUniversalActivationAuthenticateOptions'

/**
 * Gets the authenticate useMutation function options depending
 * on the account type we're doing authentication for.
 * @param authenticateProps @see {@link AuthenticateUseMutationProps} - options for the Authenticate query
 * @returns an obj with the mutation key, mutation fn, and whatever other options
 */
const getAuthenticateMutationOptions = ({
  authType = PAYLATER_AUTH_FLOW,
  config = defaultConfig,
  mutationOptions = {}
}: AuthenticateUseMutationProps): AuthenticateMutationOption => {
  const authenticateOptionsConfig = { config, mutationOptions }

  switch (authType) {
    case SECURED_INSTALLMENTS_FLOW:
      return makeSecuredAuthenticateOptions(authenticateOptionsConfig)
    case UPAG_AUTH_FLOW:
    case UNIVERSAL_ACTIVATION_FLOW:
      return makeUniversalActivationAuthenticateOptions(
        authenticateOptionsConfig
      )
    case PAYLATER_AUTH_FLOW:
    default:
      return makePaylaterAuthenticateOptions(authenticateOptionsConfig)
  }
}

export default getAuthenticateMutationOptions
